import { FoundationSkills } from '../../components/Dashboard/DashboardContainerBody';
import { StudentSkillStates } from '../../models/StudentSkillState';

const hasOverallLevel = (skill: FoundationSkills): boolean =>
  'overallLevel' in skill && skill.overallLevel !== undefined && skill.overallLevel !== null;

const compareByDifficulty = (a: FoundationSkills, b: FoundationSkills): number =>
  (a.difficulty ?? Number.POSITIVE_INFINITY) - (b.difficulty ?? Number.POSITIVE_INFINITY);

export const sortFoundationsSkills = (skills: FoundationSkills[] | null): FoundationSkills[] => {
  if (!skills) {
    return [];
  }

  const withoutOverallLevel = skills.filter(skill => !hasOverallLevel(skill)).sort(compareByDifficulty);

  const withOverallLevel = skills
    .filter(skill => hasOverallLevel(skill))
    .sort((a, b) => b.overallLevel - a.overallLevel || compareByDifficulty(a, b));

  return [...withoutOverallLevel, ...withOverallLevel];
};

export const skillSelector = (
  foundations: FoundationSkills[],
  skillCardsInfo: StudentSkillStates[],
): StudentSkillStates[] => {
  const result: StudentSkillStates[] = [];
  foundations.forEach(fd => {
    const skillCard = skillCardsInfo.find(element => element.skill.id === `SkillNode:${fd.id}`);
    if (skillCard) {
      result.push(skillCard);
    }
  });

  return result;
};
